import { LoadingSpinner } from '@shared/components';
import styles from './Button.module.css';

function Button({
    children,
    variant = 'send',
    size = 'normal',
    loading = false,
    disabled = false,
    align = 'center',
    type = 'button',
    onClick,
    ...props
}) {
    return (
        <button 
        type={type}
        className={`${styles.button} ${styles[size]} ${styles[variant]} ${styles[align]}`}
        disabled={disabled || loading}
        onClick={onClick}
        {...props}
        >
            {loading ? <LoadingSpinner /> : children}
        </button>
    );
}

export default Button;